import React from 'react';

import { useNavigate } from 'react-router-dom';

import moment from 'moment';

import styles from '../../assets/styles/CreditLineRecentActivitiesTable.module.scss';
import { formatUSDCurrency } from '../../helpers/format';
import Button from '../common/Button';

const CreditLineRecentActivitiesTable = ({ activities = [], fullPage, id }) => {
  const activitiesList = fullPage ? activities : activities.slice(0, 20);
  const navigate = useNavigate();
  const getActivityStatus = (status) => {
    if (status.toString().toLowerCase().includes('completed')) {
      return (
        <span className={`${styles.status} ${styles.status_success}`}>
          {status.slice(0, 1).toUpperCase() + status.slice(1)}
        </span>
      );
    } else {
      return (
        <span className={`${styles.status} ${styles.status_pending}`}>
          {status.slice(0, 1).toUpperCase() + status.slice(1)}
        </span>
      );
    }
  };

  const renderActionsColumn = (index) => {
    return (
      <Button type="text" onClick={() => navigate(`/account/${id}/activities/${index}`)}>
        View Details
      </Button>
    );
  };

  const tableStyle = `${styles.CreditLineRecentActivitiesTable} ${fullPage && styles.fullPage}`;

  return (
    <table className={tableStyle} id="creditLineActivities">
      <colgroup>
        <col />
        <col />
        <col />
        <col />
      </colgroup>
      <thead>
        <tr>
          <td>Type</td>
          <td>Date</td>
          <td>Amount</td>
          <td>Status</td>
        </tr>
      </thead>
      <tbody>
        {activitiesList.map((action, index) => {
          return (
            <tr key={index}>
              <td>{action.type}</td>
              <td>{moment(action.date).format('D MMM YYYY')}</td>
              <td>{formatUSDCurrency(action.amount, 2, true)}</td>
              <td>
                <span>{getActivityStatus(action.status)}</span>
                {renderActionsColumn(index)}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default CreditLineRecentActivitiesTable;
